// Constantes pour la page de login

export const LOGIN_CONSTANTS = {
  // Messages d'erreur
  MESSAGES: {
    EMAIL_REQUIRED: 'L\'email est requis',
    IDENTIFIER_REQUIRED: 'L’e-mail ou le nom d’utilisateur est requis',
    EMAIL_INVALID: 'Format d\'email invalide',
    PASSWORD_REQUIRED: 'Le mot de passe est requis',
    PASSWORD_MIN_LENGTH: 'Le mot de passe doit contenir au moins 6 caractères',
    LOGIN_ERROR: 'Erreur de connexion',
    NETWORK_ERROR: 'Impossible de se connecter au serveur. Vérifiez votre connexion internet.',
    AUTH_FAILED: 'Identifiant ou mot de passe incorrect.',
    GENERIC_AUTH_ERROR: 'Impossible de se connecter pour le moment. Veuillez réessayer.'
  },

  // Validation
  VALIDATION: {
    MIN_PASSWORD_LENGTH: 6,
    EMAIL_REGEX: /\S+@\S+\.\S+/,
    /** Connexion : local@hôte (aligné avec backend/constants VALIDATION.LOGIN_EMAIL_SHAPE_REGEX) */
    LOGIN_EMAIL_SHAPE_REGEX: /^[^\s@]+@[^\s@]+$/
  },

  // Placeholders
  PLACEHOLDERS: {
    IDENTIFIER: 'E-mail ou nom d’utilisateur',
    EMAIL: 'Entrez votre e-mail',
    PASSWORD: 'Entrez votre mot de passe'
  },

  // Animation
  ANIMATION: {
    DELAY: 100,
    DURATION: 600
  },

  // Styles
  STYLES: {
    LOGO_SIZE: 80,
    CARD_PADDING: 5,
    BORDER_RADIUS: 20
  }
};

// Types d'erreurs
export const ERROR_TYPES = {
  VALIDATION: 'validation',
  NETWORK: 'network',
  AUTH: 'auth',
  SERVER: 'server'
};

// États du formulaire
export const FORM_STATES = {
  IDLE: 'idle',
  SUBMITTING: 'submitting',
  SUCCESS: 'success',
  ERROR: 'error'
};
